import { http } from "@/utils/index";

export function uploadImage() {
  return http.request("post", "/upload/image", {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

export function saveHomeBanner(data) {
  return http.request("post", "/home/banner", {
    data
  });
}

export function leftLikeDict(key, language = null) {
  const params = { key }
  if (language) {
    params.language = language
  }
  return http.request("get", "/dict/leftLike", {
    params
  });
}

export function leftLikeDicts(keys, language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/dict/leftLikes/" + keys.join(","), {
    params
  });
}

export function saveDict(data) {
  return http.request("post", "/dict/save", {
    data
  });
}

// 根据前缀删除
export function deleteDict(key) {
  return http.request("delete", "/dict/delete", {
    params: {
      key
    }
  });
}

export function saveChildrenDict(data) {
  return http.request("post", "/dict/children/save", {
    data
  });
}

export function deleteChildrenDict(key) {
  return http.request("delete", "/dict/children/delete", {
    params: {
      key
    }
  });
}


export function getHomeContent(sectionType = null, language = null) {
  const params = {}
  if (sectionType) {
    params.sectionType = sectionType
  }
  if (language) {
    params.language = language
  }
  return http.request("get", "/home-content", {
    params
  });
}

export function getSectionContent(sectionKey, language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", `/home-content/section/${sectionKey}`, {
    params
  });
}

export function getSectionTypeContent(sectionType, language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", `/home-content/type/${sectionType}`, {
    params
  });
}

// 轮播图专用API
export function getHomeBanner(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/home-content/banner", {
    params
  });
}


export function getAllLinks(language = null) {
  const params = {}
  if (language) {
    params.language = language
  }
  return http.request("get", "/link", {
    params
  });
}

export function createLink(data) {
  return http.request("post", "/link", {
    data
  });
}

export function deleteLink(id) {
  return http.request("delete", "/link/" + id, {});
}
